"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleAnalytics = exports.cookieRemove = exports.getCookieCategoriesAcceptance = void 0;
// This function would most likely be located in a cookieinformation or utility file, 
// but for simplicity, it was moved here
var getCookieCategoriesAcceptance = function () {
    var cookieInstance = window["CookieInformation"];
    var functionalCookiesCategory = "cookie_cat_functional";
    var marketingCookiesCategory = "cookie_cat_marketing";
    var statisticCookiesCategory = "cookie_cat_statistic";
    if (!cookieInstance || !cookieInstance.getConsentGivenFor) {
        return {
            functional: false,
            marketing: false,
            statistic: false
        };
    }
    return {
        functional: cookieInstance.getConsentGivenFor(functionalCookiesCategory),
        marketing: cookieInstance.getConsentGivenFor(marketingCookiesCategory),
        statistic: cookieInstance.getConsentGivenFor(statisticCookiesCategory)
    };
};
exports.getCookieCategoriesAcceptance = getCookieCategoriesAcceptance;
// This function would most likely be located in a utility file, but for simplicity, 
// it was moved here
var cookieRemove = function (cookieName, cookieDomain) {
    var domain = cookieDomain ? "Path=/; Domain=".concat(cookieDomain, "; ") : '';
    document.cookie = "".concat(cookieName, "=;").concat(domain, "Expires=Thu, 01 Jan 1970 00:00:01 GMT;");
};
exports.cookieRemove = cookieRemove;
var GoogleAnalytics = function (settings) {
    // Function to track file download
    var handleFileTitleDownloadClick = function (event, settings) {
        // Handle click event for elements with class className
        var childDiv = event.target;
        var anchor = childDiv.parentNode;
        sendGAData(anchor);
    };
    // Function to track file download
    var handleFileLinkDownloadClick = function (event, settings) {
        // Handle click event for elements with class className
        var anchor = event.target;
        sendGAData(anchor);
    };
    var sendGAData = function (anchor) {
        if (anchor) {
            var linkText = anchor.textContent.trim();
            var linkUrl = anchor.href.trim();
            var fileName = linkUrl.substring(linkUrl.lastIndexOf('/') + 1); // Extract file name from URL
            var fileExtension = fileName.split('.').pop(); // Extract file extension from file name
            var gtag_1 = function () {
                window.dataLayer.push(arguments);
            };
            gtag_1('config', settings.tagManagerId);
            gtag_1('event', 'file_download', {
                'file_extension': fileExtension,
                'file_name': fileName,
                'link_text': linkText,
                'link_url': linkUrl,
                'user_id': settings.googleAnalyticsUserId,
                "page": window.location.href,
                "page_language": settings.language,
            });
        }
    };
    // When CookieInformation is loaded we need to trigger this function
    // because, in case a user rejects statistical cookies, we need to remove
    // tracking of the user
    window.addEventListener('CookieInformationConsentGiven', function (event) {
        event = __assign(__assign({}, event), { origin: event.target.location.origin });
        // For security always check origin when using eventlisteners
        if (event.origin !== settings.applicationUrl) {
            return;
        }
        // Get user cookie acceptance from cookieinformation
        var acceptance = (0, exports.getCookieCategoriesAcceptance)();
        // If the user has accepted statistic cookies we can continue
        if (acceptance && acceptance.statistic) {
            (function () {
                // Function to get csp nonce
                var getNonceFromMetaTag = function () {
                    var scriptTags = document.getElementsByTagName('script');
                    var nonces = [];
                    for (var i = 0; i < scriptTags.length; i++) {
                        var nonce = scriptTags[i].nonce;
                        if (nonce && nonce.length > 0) {
                            nonces.push(nonce);
                        }
                    }
                    if (nonces.length > 0) {
                        return nonces[0];
                    }
                    return null;
                };
                // Enable google analytics
                window['ga-disable-' + settings.analyticsId] = false;
                var existingHeadElement = document.getElementById("googleTagManager_head");
                if (!existingHeadElement) {
                    var googleTagManager_head = document.createElement('script');
                    var nonce = getNonceFromMetaTag();
                    if (nonce) {
                        // Add a generated nonce to the script include for the googleTagManager script when adding inline scripts to our page  
                        googleTagManager_head.setAttribute('nonce', nonce);
                    }
                    googleTagManager_head.id = "googleTagManager_head";
                    googleTagManager_head.innerText = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.id='googleTagManager_head_async';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','" + settings.tagManagerId + "');";
                    document.head.insertBefore(googleTagManager_head, document.head.lastChild);
                }
                var existingBodyElement = document.getElementById("googleTagManager_body");
                if (!existingBodyElement) {
                    var googleTagManager_body = document.createElement('noscript');
                    googleTagManager_body.id = "googleTagManager_body";
                    var googleTagManager_body_iframe = document.createElement('iframe');
                    googleTagManager_body_iframe.src = "https://www.googletagmanager.com/ns.html?id=" + settings.tagManagerId;
                    googleTagManager_body_iframe.height = "0";
                    googleTagManager_body_iframe.width = "0";
                    googleTagManager_body_iframe.style.display = "none";
                    googleTagManager_body_iframe.style.visibility = "hidden";
                    googleTagManager_body.appendChild(googleTagManager_body_iframe);
                    document.body.insertBefore(googleTagManager_body, document.body.firstChild);
                }
                // Function to add a script tag to the head with a nonce
                var addScriptToHead = function (src) {
                    var script = document.createElement('script');
                    script.src = src;
                    script.async = true;
                    var nonce = getNonceFromMetaTag();
                    if (nonce) {
                        script.nonce = nonce;
                    }
                    document.head.appendChild(script);
                };
                // Add the Google Analytics to the head
                addScriptToHead("https://www.googletagmanager.com/gtag/js?id=".concat(settings.tagManagerId));
                // Function to initialze Google Analytics
                window.dataLayer = window.dataLayer || [];
                var gtag = function () {
                    window.dataLayer.push(arguments);
                };
                gtag('config', settings.tagManagerId, {
                    'user_id': settings.googleAnalyticsUserId,
                    "event": "virtualPageview",
                    "page": window.location.href,
                    "page_language": settings.language,
                });
                // Download link on category page
                var titleElements = document.querySelectorAll('.download-analytics-title');
                titleElements.forEach(function (element) {
                    element.addEventListener('click', function (event) {
                        handleFileTitleDownloadClick(event, settings);
                    });
                });
                var linkElements = document.querySelectorAll('.download-analytics-link');
                linkElements.forEach(function (element) {
                    element.addEventListener('click', function (event) {
                        handleFileLinkDownloadClick(event, settings);
                    });
                });
            })();
        }
        else {
            // Disable google analytics
            window['ga-disable-' + settings.analyticsId] = true;
            // Delete Google Analytics cookies
            var hostname = window.location.hostname;
            (0, exports.cookieRemove)("_gat_".concat(settings.analyticsId), hostname);
            (0, exports.cookieRemove)('_gid', hostname);
            (0, exports.cookieRemove)('_ga=', hostname);
            var titleElements = document.querySelectorAll('.download-analytics-title');
            titleElements.forEach(function (element) {
                var elementClone = element.cloneNode(true);
                element.parentNode.replaceChild(elementClone, element);
            });
            var linkElements = document.querySelectorAll('.download-analytics-link');
            linkElements.forEach(function (element) {
                var elementClone = element.cloneNode(true);
                element.parentNode.replaceChild(elementClone, element);
            });
        }
    }, false);
    return null;
};
exports.GoogleAnalytics = GoogleAnalytics;
